import { FC } from "react";

export const ErrorPage:FC = () => {
  return (
        <div>
            <h1>Error</h1>
        </div>
    )
}